export const TURN_TIME = 10000;
export const NO_TURN_TIME = false;
export const HAND_CARDS = 5;
export const GAME_MAX_POINTS = 3;

export const RAIL_SIZE = 8;
